module.exports = __webpack_public_path__ + "img/european-union.5114e087.svg";